<div class="coupons-preview"
     [class.device-desktop]="deviceType === 'desktop'"
     [class.device-tablet]="deviceType === 'tablet'"
     [class.device-mobile]="deviceType === 'mobile'"
     [class.page-loaded]="isPageLoaded">
  
  <!-- Hero Section (contains header inside) -->
  <section 
    class="hero-section website-element coupons-hero-element" 
    *ngIf="isSectionVisible('hero') && heroSectionData?.active !== false"
    [class.selected]="getCouponSectionElement()?.selected"
    [ngStyle]="getHeroBackgroundStyle()">
    
    <!-- Header Section inside Hero -->
    <div class="hero-header-wrapper" (click)="onHeaderClick()">
      <div class="website-element header-element" 
           *ngIf="isSectionVisible('header')"
           [class.selected]="getHeaderElement()?.selected">
        <app-champs-page-header
          [logo]="getHeaderLogo()"
          [navigation]="getHeaderNavigation()"
          [ctaButton]="getHeaderCTAButton()"
          [visible]="true"
          [clickable]="true"
          [selected]="getHeaderElement()?.selected || false"
          [headingColor]="headingColor"
          [headingFont]="headingFont"
          [backgroundColor]="getHeaderBackgroundColor()"
          [deviceType]="deviceType"
          (navigationClick)="onNavigationClick($event)">
        </app-champs-page-header>
      </div>
    </div>

    <!-- Hero Content -->
    <div class="hero-content-wrapper" (click)="onPageHeaderSectionClick($event)">
      <div class="hero-container">
        <h1 class="hero-title"
            [style.color]="heroSectionData?.content?.heading?.style?.color || '#FFFFFF'"
            [style.font-family]="getHeadingFont()"
            [ngStyle]="getTitleStyles()">{{ getPageTitle() }}</h1>
        <p class="hero-subtitle"
           [style.color]="heroSectionData?.content?.subheading?.style?.color || '#FFFFFF'"
           [style.font-family]="getBodyFont()">{{ getPageSubtitle() }}</p>
      </div>
      
      <!-- Coupons Images (inside hero section) -->
      <div class="coupons-container" 
           *ngIf="getCoupons().length > 0"
           (click)="onCouponCardClick($event)">
        <div class="coupon-image-card" *ngFor="let coupon of getCoupons(); trackBy: trackByIndex">
          <img [src]="getCouponImageUrl(coupon)" 
               [alt]="coupon?.alt || 'Coupon'"
               class="coupon-image"
               (error)="onCouponImageError($event)">
            </div>
          </div>

      <!-- Instructions Section (inside hero section) -->
      <div 
        class="instructions-section website-element coupons-instructions-element" 
        *ngIf="(getInstructionHeading() || getInstructionParagraph())"
        [class.selected]="getInstructionsElement()?.selected"
        (click)="onInstructionsSectionClick($event)">
        <div class="instructions-container">
          <div class="instructions-card">
            <h2 class="instructions-title"
                *ngIf="getInstructionHeading()"
                [style.color]="getHeadingColor()"
                [style.font-family]="getHeadingFont()">{{ getInstructionHeading() }}</h2>
            
            <p class="instructions-paragraph"
               *ngIf="getInstructionParagraph()"
               [style.color]="getParagraphColor()"
               [style.font-family]="getBodyFont()">{{ getInstructionParagraph() }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <!-- Footer -->
  <div class="website-element footer-element" 
       *ngIf="isSectionVisible('footer')"
       [class.selected]="getFooterElement()?.selected"
       (click)="onFooterClick($event)">
    <app-champs-page-footer 
      [quickLinks]="getFooterQuickLinks()"
      (quickLinkClick)="onNavigationClick($event)"
      [quickLinksTitle]="getFooterQuickLinksTitle()"
      [socialLinks]="getFooterSocialLinks()"
      [socialLinksTitle]="getFooterSocialLinksTitle()"
      [copyright]="getFooterCopyright()"
      [logo]="getFooterLogo()"
      [deviceType]="deviceType"
      [backgroundColor]="getFooterBackgroundColor()">
    </app-champs-page-footer>
  </div>
</div>

